export default {
    name: 'performance_code',
    definition: {},
};
